import React from 'react';
import { useLocation } from 'react-router-dom';
import PrivateSection from 'routes/PrivateSection';
import PublicRoutes from 'routes/PublicRoutes';
import { getToken,getDataSession } from 'views/Utils/Common';

function Routes() {
    const { pathname } = useLocation();
    const isUserLoggedIn = (getToken() != null) && (getDataSession('empresa') != null) && (getDataSession('sucursal') != null);

    if(pathname === "/")
       return <PublicRoutes />;
    return isUserLoggedIn ? <PrivateSection /> : <PublicRoutes />;
}

export default Routes;
